import React, { useState } from "react";

const IntroVideo = ({ onVideoEnd }) => {
  const [fadeOut, setFadeOut] = useState(false);

  const handleVideoEnd = () => {
    setFadeOut(true);
    setTimeout(() => {
      onVideoEnd();
    }, 1000); // Match fade-out timing
  };

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-[#E5E5E5] transition-opacity duration-1000 flex items-center justify-center border-none ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <video
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnd}
        className="w-full h-auto sm:w-auto sm:h-full object-contain"
      >
        <source
          src="https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/videos/Arkbuild+Logo+Animation+-+Lines.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default IntroVideo;
